import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, ChildActivationEnd, ChildActivationStart, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet, RoutesRecognized } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoaderService } from './core/shared/services/loader.service';
import { CommonModule } from '@angular/common';
import { InactivityService } from './core/services/inactivity.service';
import { AuthService } from './core/services/auth.service';
import { SessionExpiredModalComponent } from './views/pages/descubrete/test-knowledge/session-expired/session-expired-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerModule, CommonModule, SessionExpiredModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'phoenix-frontend-web';

  router = inject(Router);
  loader = inject(LoaderService);
  authService = inject(AuthService);
  inactivityService = inject(InactivityService);
  
  private routerSubscription: any;

  ngOnInit(): void {
    // Mantener la funcionalidad original de router events
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Removido console.log para evitar bucles infinitos
        // console.log('router-NavigationStart', this.router.url);
      }
      if (event instanceof NavigationEnd) {
        this.loader.hide();
      }
    });

    // Inicializar el servicio de inactividad si el usuario está autenticado
    if (this.authService.isLoggedIn()) {
      this.inactivityService.init();
    }
    
    // Suscribirse a los cambios de inicio de sesión para iniciar el monitoreo
    this.authService.signInObservable.subscribe(user => {
      if (user) {
        this.inactivityService.init();
      }
    });
    
    // Detener el monitoreo cuando el usuario cierra sesión
    this.authService.signOutObservable.subscribe(() => {
      this.inactivityService.stopWatching();
    });
  }

  // Método para limpiar suscripciones (llamado manualmente si es necesario)
  private cleanupSubscriptions(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}